const BaseContainer = ({ children, fullWidth = false, className = '' }: { children: React.ReactNode, fullWidth?: boolean, className?: string }) => {
  return (
    <div className="m-container">
        <div className={`m-container__inner ${fullWidth ? 'w-full' : ''} ${className}`}>
        {children}
        </div>
    </div>
  );
}

export default BaseContainer;